import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OrderEntityParams {
  id: number;
}
export class OrderEntity extends BaseEntityClass {
  id: number;
  constructor(params: OrderEntityParams) {
    super();
    this.type = "order";
    this.entity_version = 2;
    this.id = params.id;
  }

  static fromOrder(order: any): OrderEntity {
    order = _.pick(order, ["id"]);

    return new OrderEntity(order);
  }
}
